import { render, staticRenderFns } from "./im_content_right.vue?vue&type=template&id=3b05beae&scoped=true&"
import script from "./im_content_right.vue?vue&type=script&lang=ts&"
export * from "./im_content_right.vue?vue&type=script&lang=ts&"
import style0 from "./im_content_right.vue?vue&type=style&index=0&id=3b05beae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b05beae",
  null
  
)

export default component.exports